import { Typography, Box } from "@mui/material";
import Placeholder from "components/Placeholder";

export default function DevelopPage() {
  return (
    <section id="engineer">
      <Box
        mt={10}
        display="grid"
        gridTemplateColumns={{ xs: "1fr", md: "1fr" }}
        // gap={5}
        height="100vh"
      >
        <Typography
          variant="h2"
          fontFamily="Canopee"
          sx={{ fontSize: { xs: "5.25rem", md: "100px" } }}
        >
          Fun
        </Typography>
        <Box>
          <Placeholder
            label="Coming soon"
            subtitle="Fun things I do will live here"
            aspectRatioMobile={3 / 4}
          />
        </Box>
      </Box>
    </section>
  );
}
